// extracted by mini-css-extract-plugin
module.exports = {"container":"e_1B","title":"e_2B","label":"e_3B"};